export const getPersonnelDetails = (pid) => {

  return $.get('Personnel/GetPersonnelDetails/'+pid)

}

export const GetMedicalConditions = (pid) => {

  return $.get('Personnel/GetMedicalConditions?PersonnelId='+pid)

}




// WEBPACK FOOTER //
// ./src/pages/UpdatePersonnel/UpdatePersonnel.service.js